/**
 * The compact type scale the tabular job and config pages share: 12px body,
 * 11px meta, mono strings that wrap instead of widening the page, and tables
 * whose cells wrap. Kept as class strings so the pages stay plain Tailwind.
 */

/** Eyebrow label over a card's content. */
export const SECTION_LABEL = 'text-11 font-semibold tracking-[0.06em] text-ink-3 uppercase'

/** One line of small, muted metadata under a heading. */
export const META_TEXT = 'text-11 leading-5 text-ink-3'

/** Monospace that breaks anywhere rather than forcing a horizontal scroll. */
export const MONO_WRAP = 'font-mono break-all [overflow-wrap:anywhere]'

/**
 * A data table at the compact scale: 12px cells that wrap, 11px muted heads,
 * everything top-aligned so a wrapped SQL cell reads next to its row.
 */
export const COMPACT_TABLE =
  'text-xs [&_th]:h-8 [&_th]:px-3 [&_th]:text-11 [&_th]:font-medium [&_th]:text-ink-3 [&_td]:px-3 [&_td]:py-1.5 [&_td]:align-top [&_td]:whitespace-normal'

/** A small rounded chip for a value in a list (header cells, example names, changed sections). */
export const CHIP =
  'inline-flex max-w-full items-center gap-1 rounded-md border border-line bg-bg-elev px-1.5 py-px text-11 leading-4 text-ink-2'

/** The chip in its warning tone: something changed here. */
export const CHIP_WARN = 'border-st-warn/40 bg-st-warn-bg text-st-warn'

/** The page column every tabular surface sits in: wide enough for a preview table, never wider than the viewport. */
export const COMPACT_PAGE = 'mx-auto flex w-full min-w-0 max-w-6xl flex-col gap-4'

/** An action button at the compact scale. */
export const COMPACT_ACTION = 'h-7 px-2.5 text-xs'

/** A ghost or outline action that drops something: red text, a light red hover. */
export const DESTRUCTIVE_ACTION = 'text-st-down hover:bg-st-down-bg hover:text-st-down'

/** The outline variant's border, in the same red. */
export const DESTRUCTIVE_OUTLINE = 'border-st-down/50 dark:border-st-down/50'
